import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const classes = {
  root: css`
    position: relative;
  `,
  popup: css`
    z-index: 1300;
  `,
  paper: css`
    overflow: hidden;
  `,
}

export const inputClasses = {
  inputRoot: css``,
  adornmentEnd: css`
    // дисплей грид фиксит верстку при очень длинном тэйле
    display: grid;
    max-width: 100%;
  `,
}

export const listItemClasses = {
  root: css`
    display: flex;
    inline-size: 100%;
    padding: ${cssTheme.spacingUnits.s} ${cssTheme.spacingUnits.m};

    &[data-focus='true'] {
      background-color: ${cssTheme.default.day.backgroundMinor};
    }
  `,
}

export const listClasses = {
  root: css`
    max-block-size: 40vh;
    overflow-y: auto;
  `,
  list: css``,
}
